module.exports = __webpack_public_path__ + "/93f284548b42ab76fe3fd03a9d3a2180.woff";